// extracted by mini-css-extract-plugin
module.exports = {"heading":"e_XD","title":"e_YD","toTopButton":"e_ZD","toTopButtonIcon":"e__D"};